import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from 'date-fns/locale';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  DatePickerProps
} from '@material-ui/pickers';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    datepicker: {
      '& .MuiInputBase-input': {
        boxShadow: 'none',
        fontSize: '1.2rem'
      },
      '& .MuiFormLabel-root': {
        fontSize: '1.4rem'
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.8rem'
      },
      '& .MuiFormHelperText-root': {
        fontSize: '1.2rem'
      }
    },
  }),
);

export default function DatePicker(props: DatePickerProps) {
  const classes = useStyles();
   
  return (
    <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
      {/* <MuiDatePicker
        value={props.value}
        margin="normal"
        clearable
        {...props}
        format="dd/MM/yyyy"
        className={classes.datepicker}
      /> */}
      <KeyboardDatePicker
        { ...props }
        className={classes.datepicker}
        margin="normal"
        onKeyPress={e => e.preventDefault()}
        id="date-picker-dialog"
        format="dd/MM/yyyy"
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        invalidDateMessage="Data em formato inválido."
        // clearable
        clearLabel="Limpar"
        cancelLabel="Cancelar"        
      />      
    </MuiPickersUtilsProvider>
  );
}
